import { db } from "../firebaseClient"
import { doc, getDoc, setDoc, increment, serverTimestamp } from "firebase/firestore"

// NOTE: awarded directly from the client on quiz/capstone submission — same class of
// limitation as client-side grading (see enrollmentHelpers). A determined learner could
// call this directly from devtools to inflate their own total. Real anti-cheat needs
// server-side grading via Cloud Functions, which is on the deferred backend-infra list.
export const awardPoints = async (userId, amount) => {
  if (!userId || !amount) return { error: null }

  try {
    const pointsRef = doc(db, "learnerPoints", userId)
    await setDoc(
      pointsRef,
      { userId, totalPoints: increment(amount), updatedAt: serverTimestamp() },
      { merge: true }
    )
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const getLearnerPoints = async (userId) => {
  if (!userId) return { totalPoints: 0, error: null }

  try {
    const pointsRef = doc(db, "learnerPoints", userId)
    const snap = await getDoc(pointsRef)
    if (!snap.exists()) return { totalPoints: 0, error: null }
    return { totalPoints: snap.data()?.totalPoints || 0, error: null }
  } catch (error) {
    return { totalPoints: 0, error }
  }
}
